// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaYoutube, FaEnvelope, FaPhone } from "react-icons/fa";

function Footer() {
  return (
    <footer className="relative bg-[#0f172a] text-gray-300">
      {/* 🌊 TOP CURVE / SEPARATOR */}
      <div className="absolute -top-10 left-0 w-full overflow-hidden leading-none">
        <svg
          className="relative block w-full h-10"
          viewBox="0 0 1440 100"
          preserveAspectRatio="none"
        >
          <path
            d="M0,40 C240,80 480,0 720,20 960,40 1200,80 1440,40 L1440,0 L0,0 Z"
            fill="#0f172a"
          />
        </svg>
      </div>

      {/* ================= MAIN FOOTER ================= */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-10 
                      grid-cols-1 sm:grid-cols-2 md:grid-cols-4">

        {/* 🔹 ABOUT */}
        <div>
          <h4 className="text-white text-lg font-bold mb-4">
            DSR Study Point
          </h4>
          <p className="text-sm leading-relaxed text-gray-400">
            Quality education for Classes 9–12 with notes, MCQs,
            videos and guidance to help students succeed.
          </p>
        </div>

        {/* 🔹 QUICK LINKS */}
        <div>
          <h4 className="text-white text-lg font-bold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="footer-link">Home</Link></li>
            <li><Link to="/courses" className="footer-link">Courses</Link></li>
            <li><Link to="/results" className="footer-link">Results</Link></li>
            <li><Link to="/contact" className="footer-link">Contact Us</Link></li>
            <li><Link to="/about" className="footer-link">About Us</Link></li>
          </ul>
        </div>

        {/* 🔹 POLICIES */}
        <div>
          <h4 className="text-white text-lg font-bold mb-4">Policies</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privacy-policy" className="footer-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="footer-link">Terms & Conditions</Link></li>
            <li><Link to="/refund-policy" className="footer-link">Refund Policy</Link></li>
            <li><Link to="/disclaimer" className="footer-link">Disclaimer</Link></li>
          </ul>
        </div>

        {/* 🔹 CONTACT */}
        <div>
          <h4 className="text-white text-lg font-bold mb-4">Contact</h4>

          <p className="flex items-center gap-2 text-sm mb-2">
            <FaEnvelope className="text-blue-400" />
            <a href="mailto:devloper.3773@gmail.com" className="hover:underline">
              devloper.3773@gmail.com
            </a>
          </p>

          <p className="flex items-center gap-2 text-sm mb-4">
            <FaPhone className="text-blue-400" />
            +91-8287441757
          </p>

          {/* SOCIAL */}
          <div className="flex gap-4 mt-4">
            <a
              href="https://www.instagram.com/the_knowledge_academy111"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn bg-pink-600"
            >
              <FaInstagram />
            </a>
            <a
              href="https://youtube.com/@deepakkumargupta620"
              target="_blank"
              rel="noopener noreferrer"
              className="social-btn bg-red-600"
            >
              <FaYoutube />
            </a>
          </div>
        </div>
      </div>

      {/* ================= BOTTOM BAR ================= */}
      <div className="border-t border-gray-700 py-4 text-center text-xs sm:text-sm text-gray-400">
        © {new Date().getFullYear()} DSR Study Point. All rights reserved.  
        <span className="block sm:inline sm:ml-2">
          Developed by <span className="text-blue-400 font-semibold">Prince</span>
        </span>
      </div>
    </footer>
  );
}

export default Footer;
